export const environment = {
  production: false,
  apiBaseUrl: 'https://nohs-formenginev2-dev1.azurewebsites.net/api',
  appInsightsInstrumentationKey: 'aa2f5c55-8854-48e1-b05c-37041cc972ba',
  appInsightsDisableTelemetry: false,
};
